<template>
    <section class="trabajos" v-loading="loading">
        
        <el-alert
            v-if="error"
            title="Ha ocurrido un error"
            type="error"
            :closable="false"
            center>
        </el-alert>
        <template v-else-if="tipos && tareas && usuarios">

            <ul class="usuarios">

                <div class="overlay" v-if="task_selected.filter(f => f.tipo_id === task_selected[0].tipo_id).length !== task_selected.length"></div>

                <!-- Listado de usuarios -->
                <li 
                    v-for="(usuario, u) in usuariosVisibles" 
                    :key="`usuario_${u}`" 
                    @drop="onDropUser($event, usuario)"
                    @dragover.prevent
                    @dragenter.prevent
                    :class="[
                        {'drag-start': drag.start},
                        {'hide': drag.tarea && usuario.tipo_id !== drag.tarea.tipo_id}
                    ]"
                >
                    <template v-if="drag.start">

                        <p>Asignar a <b>{{ usuario.name }}</b></p>

                    </template>
                    <template v-else>

                        <h1>
                            <p>{{ usuario.name }}</p> 
                            <span @click="disabledUser(usuario)">🞨</span>
                        </h1>

                        <!-- Tipo -->
                        <el-select :value="usuario.tipo_id" @change="val => setUserTipo(usuario, val)" placeholder="Selecciona">
                            <el-option
                                v-for="(tipo, t) in getTiposByUser(usuario)"
                                :key="`usuario_${u}_tipo_${t}`"
                                :label="tipo.name"
                                :value="tipo.id">
                            </el-option>
                        </el-select>

                        <!-- Tarea -->
                        <div :class="['tarea', {'empty': !usuario.tarea_id}]">

                            <span v-if="usuario.lista_tareas && usuario.lista_tareas.length" class="badge">+ {{ usuario.lista_tareas.length }}</span>

                            <p v-if="usuario.tarea_id">{{getTareaById(usuario.tarea_id).name}}</p>
                            <p v-else>Sin asignar tarea</p>
                        </div>
                    </template>
                </li>

                <!-- Nuevo usuario -->
                <li class="nuevo" v-if="!drag.start" @click="dialogUsers.open = true">
                    <p>Añadir usuario</p>
                </li>
            </ul>

            <!-- Acciones -->
            <section class="actions">

                <p>
                    Ver solo tareas asignadas 
                    <el-switch v-model="tareas_asignadas"/>
                </p>

                <div>
                    <el-button 
                        type="default" 
                        v-if="task_selected.length" 
                        :disabled="!task_selected.length" 
                        @click="task_selected = []">CANCELAR
                    </el-button>

                    <el-button 
                        type="primary" 
                        :disabled="!task_selected.length" 
                        @click="confirmLiberarTask()">LIBERAR
                    </el-button>

                    <el-button 
                        type="success" 
                        :disabled="!task_selected.length" 
                        @click="confirmPriorizarTask()">PRIORIZAR
                    </el-button>
                </div>
            </section>

            <!-- Listado de tareas -->
            <ul class="tipos">
                <li v-for="(tipo, t) in tipos" :key="`tipo_${t}`">

                    <b @dblclick="openWindowEntity(tipo)">
                        {{ tipo.name }}
                        <span>{{ getTareasByTipo(tipo).length }}</span>
                    </b>

                    <ul
                        class="tareas"
                        @dragover.prevent
                        @dragenter.prevent
                    >
                        <li
                        v-for="(tareas, ti) in getTareasByTipo(tipo)"
                        :key="`tipo_${t}_tarea_${ti}`"
                        :class="[{'asignada': tareas[0].asignada, 'selected': task_selected.map(m => m.id).includes(tareas[0].id)}]"
                        @click="selectTask(tareas[0])"
                        :draggable="tareas[0].asignada || task_selected.some(s => s.asignada) ? false : true"
                        @dragstart="startDrag($event, tareas[0])"
                        @dragend="dragEnd">
                            <p>{{ tareas[0].name }}</p>
                            <span v-if="tareas.length > 1">
                                {{ `x ${tareas.length}` }}
                            </span>
                        </li>
                    </ul>
                </li>
            </ul>

            <!-- Modal seleccion de usuarios no visibles -->
            <el-dialog
                title="Seleciona uno o varios operarios"
                :visible.sync="dialogUsers.open"
                width="500px"
                class="dialog-users"
                @close="closeDialogUsers">

                <!-- usuarios no visibles -->
                <ul v-if="usuarios.filter(f => !f.activo).length">
                    <li 
                    v-for="(user, u) in usuarios.filter(f => !f.activo)" 
                    :key="`usuario_${u}`" 
                    @click="selectDialogUser(user)"
                    :class="[{'selected': dialogUsers.selected.includes(user.id)}]">
                        {{ user.name }}
                    </li>
                </ul>
                <el-alert
                    v-else
                    title="No hay más operarios"
                    type="info"
                    :closable="false"
                    center>
                </el-alert>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogUsers.open = false">Cancelar</el-button>
                    <el-button type="primary" v-if="usuarios.filter(f => !f.activo).length" @click="saveDialogUsers()">Añadir</el-button>
                </span>
            </el-dialog>
        </template>

    </section>
</template>

<script>
    import {
        getUrl,
        getDataControlTrabajo,
        postDataControlTrabajo
    } from '@/helpers/api'

	export default {
        name: 'ControlTrabajos',
        props: {
            id: String,
            ficha: Object,
            entidad: String,
            porlet: Object,
            currentAction: Object,
            reload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            autoReload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            visibleReload: {
                type: Boolean,
                required: false,
                default: () => false
            }
        },
		data () {
			return {
                loading: false,
                error: null,
                drag: {
                    start: false, // Indica que se esta haciendo drag
                    tarea: null // Tarea seleccionada
                },
                dialogUsers: {
                    open: false,
                    selected: []
                },

                // Tipos de trabajo
                tipos: null,

                // Tareas asociadas a un tipo de trabajo
                tareas: null,

                // Usuarios
                usuarios: null,

                // Tareas seleccionadas para liberar o priorizar
                task_selected: [],
                block_key: false, // Bloquea pulsar tecla L y P
                tareas_asignadas: false // Ver solo tareas asignadas
            }
        },
        computed: {
            usuariosVisibles() {
                return this.usuarios.filter(f => f.activo)
            }
        },
        mounted() {
            
            // Presionar teclas L y P
            let _keyPress = (evt) => {

                evt.preventDefault()

                if(this.block_key) return

                if (evt.keyCode === 76) this.confirmLiberarTask()
                if (evt.keyCode === 80) this.confirmPriorizarTask()
            }
            document.addEventListener('keyup', _keyPress)
            
            //if (process.env.production) {
                setInterval(() => {
                    this.getData()
                }, 3000)
            //}

            this.getData()

            this.$emit('created')
        },
        methods: {
            async getData() {

                if (this.loading) return
                
                this.error = false
                
                try {

                    let {data} = await getDataControlTrabajo()
                    
                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                } catch(err) {

                    this.error = true
                }
            },
            nuevaVentana(option) {
                this.$emit('openWindow', option)
            },
            refresh() {
                this.getData()
            },
            // Obtener tipos de tarea por usuario
            getTiposByUser(user) {
                return this.tipos.filter(f => user.tipos.map(m => Number(m)).includes(Number(f.id)))
            },
            // Obtener tareas sin asignar por tipo
            getTareasByTipo(tipo) {

                let user_tareas = this.usuarios

                let user_tareas_ids = user_tareas.map(m => m.tarea_id)

                let user_tareas_proximas = user_tareas.reduce((acum, obj) => {
                    acum.push(...obj.lista_tareas.map(m => Number(m)))
                    return acum
                }, [])

                let tareas = this.tareas.filter(f => {

                    if(this.tareas_asignadas)  return f.tipo_id === tipo.id && user_tareas_proximas.includes(f.id)
                    
                    return f.tipo_id === tipo.id && f.visible && !user_tareas_ids.includes(f.id)

                }).sort((a, b) => a.PRIORIDAD - b.PRIORIDAD).map(m => {
                    return {
                        ...m,
                        asignada: user_tareas_proximas.includes(m.id)
                    }
                })

                return Object.values(this.groupBy(tareas, 'name'))
            },
            getTareaById(tarea_id) {
                return this.tareas.find(f => f.id === tarea_id)
            },
            async setUserTipo(usuario, val) {

                if (this.loading) return
                
                this.error = false

                this.loading = true

                try {

                    let {data} = await postDataControlTrabajo({
                        usuario_id: usuario.id,
                        tipo_id: val
                    })
                    
                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                } catch(err) {

                    this.error = true
                }

                this.loading = false

            },
            // Arrastrar tarea
            startDrag(evt, tarea) {
                
                // Si se han seleccionado varias tareas se comprueba que sean del mismo tipo para poder hacer drag
                if(
                    this.task_selected.length && 
                    this.task_selected.filter(f => f.tipo_id === this.task_selected[0].tipo_id).length !== this.task_selected.length
                ) {
                    this.$notify({
                        title: 'Ups!',
                        message: 'Solo puedes asignar varias tareas del mismo tipo',
                        type: 'warning'
                    });

                    this.dragEnd()

                    return
                }

                // Si se han seleccionado varias tareas del mismo tipo haremos drag
                let tareas = []

                if (this.task_selected.length) {
                    tareas = this.task_selected.map(m => m.id)
                } else {
                    tareas = [tarea.id]
                }
                console.log(tareas)
                this.drag.start = true
                this.drag.tarea = tarea
                
                evt.dataTransfer.dropEffect = 'move'
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('lista_tareas', tareas)
            },
            // Zona de usuario (asignar tarea)
            async onDropUser(evt, usuario) {

                let lista_tareas = evt.dataTransfer.getData('lista_tareas').split(',').map(m => Number(m))

                let usuario_id = Number(this.usuarios.find(f => f.id === usuario.id).id)

                if (this.loading) return
                
                this.error = false

                this.loading = true

                try {

                    let {data} = await postDataControlTrabajo({usuario_id, lista_tareas})
                    
                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                } catch(err) {

                    this.error = true
                }

                this.loading = false

                // usuarioSelected.tarea_id = Number(tarea_id)

                // Ocultar tarea de la lista de tareas
                // this.tareas.find(f => f.id === Number(tarea_id)).visible = false

                this.dragEnd()
                
            },
            // Finalizar evento drag
            dragEnd() {
                this.drag.start = false
                this.drag.tarea = null
            },

            // Añadir usuarios no visibles
            selectDialogUser(user) {

                let userIndex = this.dialogUsers.selected.findIndex(f => f == user.id)

                if (userIndex >= 0) {
                    this.dialogUsers.selected.splice(userIndex, 1)
                } else {
                    this.dialogUsers.selected.push(user.id)
                }
            },
            closeDialogUsers() {
                this.dialogUsers.selected = []
            },
            async saveDialogUsers() {
                
                if (this.loading) return
                
                this.error = false

                this.loading = true

                try {

                    let {data} = await postDataControlTrabajo({
                        activo: true,
                        usuarios: this.dialogUsers.selected
                    })
                    
                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                    this.dialogUsers.open = false

                } catch(err) {

                    this.error = true
                }

                this.loading = false
            },
            async disabledUser(usuario) {
                
                if (this.loading) return
                
                this.error = false

                this.loading = true

                try {

                    let {data} = await postDataControlTrabajo({
                        activo: false,
                        usuario_id: usuario.id
                    })
                    
                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                } catch(err) {

                    this.error = true
                }

                this.loading = false
            },

            // Seleccionar tareas / priorizar y liberar
            selectTask(tarea) {
                
                let find_task = this.task_selected.findIndex(f => +f.id === +tarea.id)

                if (find_task >= 0) {
                    this.task_selected.splice(find_task, 1)
                } else {
                    this.task_selected.push(tarea)
                }

            },
            confirmLiberarTask() {

                if(!this.task_selected.length) return

                this.block_key = true

                this.$confirm(`¿Quieres liberar las ${this.task_selected.length} tareas que has seleccionado ?`, 'Liberar tareas', {
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {

                    this.liberarTask()
                    this.block_key = false

                }).catch(() => {
                    
                    this.task_selected = []
                    this.block_key = false
                })
            },
            async liberarTask() {
                
                this.loading = true

                try {
                    
                    let {data} = await postDataControlTrabajo({
                        lista_tareas: this.task_selected.map(m => m.id),
                        action: "liberar"
                    })

                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                    this.$notify({
                        title: '¡Bien!',
                        message: 'Tareas liberadas',
                        type: 'success'
                    })

                    this.task_selected = []

                } catch (e) {
                    
                    this.$notify.error({
                        title: 'Error',
                        message: 'Ha ocurrido un error'
                    })
                }
                
                this.loading = false
            },
            confirmPriorizarTask() {
                
                if(!this.task_selected.length) return

                this.block_key = true

                this.$confirm(`¿Quieres priorizar las ${this.task_selected.length} tareas que has seleccionado ?`, 'Priorizar tareas', {
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {

                    this.priorizarTask()
                    this.block_key = false

                }).catch(() => {
                    
                    this.task_selected = []
                    this.block_key = false
                })
                
            },
            async priorizarTask() {

                this.loading = true

                try {
                    
                    let {data} = await postDataControlTrabajo({
                        lista_tareas: this.task_selected.map(m => m.id),
                        action: "priorizar"
                    })

                    this.tareas = data.tareas
                    this.tipos = data.tipos
                    this.usuarios = data.usuarios

                    this.$notify({
                        title: '¡Bien!',
                        message: 'Tareas priorizadas',
                        type: 'success'
                    })

                    this.task_selected = []

                } catch (e) {
                    
                    this.$notify.error({
                        title: 'Error',
                        message: 'Ha ocurrido un error'
                    })
                }
                
                this.loading = false
            },
            openWindowEntity(tipo) {
                window.open(`/#${tipo.link}`)
            },

            // Utils
            groupBy(xs, key) {
                return xs.reduce(function(rv, x) {
                    (rv[x[key]] = rv[x[key]] || []).push(x);
                    return rv;
                }, {});
            }
        }
	}
</script>

<style lang="scss">
section.trabajos {
    overflow: hidden;
    height: 100%;
    background-color: #edeff3;
    display: flex;
    flex-flow: column;

    > ul {
        display: flex;
        margin: 0px;
        padding: 0px;
        list-style: none;

        &.usuarios {
            position: relative;
            margin: 0px;
            flex-shrink: 0;
            .overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #edeff3ba;
                z-index: 2;
            }
            li {
                display: flex;
                flex-flow: column;
                border: 1px solid #dcdfe6;
                border-radius: 8px;
                background-color: white;
                margin: 5px;
                padding: 10px;
                width: 150px;
                height: 140px;
                &.nuevo {
                    background-color: #ffffff96;
                    border: 2px dashed #dcdfe6;
                    text-align: center;
                    width: 100px;
                    height: 140px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #6e6e6e;
                    cursor: pointer;
                    &:hover {
                        background-color: white;
                    }
                }
                &.drag-start {
                    background-color: rgb(240, 249, 235);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &:hover {
                        background-color: rgb(225, 243, 216);
                    }
                    &.hide {
                        visibility: hidden;
                    }
                    p {
                        text-align: center;
                        color: #67C23A;
                    }
                }
                h1 {
                    margin: 0px 0px 10px 0px;
                    display: flex;
                    justify-content: space-between;
                    p {
                        margin: 0px;
                    }
                    span {
                        cursor: pointer;
                    }
                }
                .tarea {
                    background-color: rgb(240, 249, 235);
                    border-radius: 4px;
                    padding: 6px 10px;
                    font-size: 0.9rem;
                    margin-top: 10px;
                    position: relative;
                    &.empty {
                        text-align: center;
                        background-color: rgb(254, 240, 240);
                        p {
                            color: #F56C6C!important;
                            font-size: 0.9rem;
                        }
                    }
                    p {
                        margin: 0px;
                        color: #67C23A;
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        text-overflow: ellipsis;
                    }
                    > span.badge {
                        position: absolute;
                        background-color: #67C23A;
                        color: white;
                        right: -7px;
                        top: -4px;
                        border-radius: 4px;
                        padding: 0px 5px;
                    }
                }
            }
        }

        &.tipos {
            background-color: $--color-background;
            flex-grow: 1;
            > li {
                display: flex;
                flex-flow: column;
                border-right: 1px solid #ffffff;
                width: calc(100% / 5);
                &:last-child {
                    border: 0px;
                }
                b {
                    padding: 10px;
                    border-bottom: 1px solid #dcdfe66e;
                    background-color: $--color-header;
                    color: white;
                    flex-shrink: 0;
                    display: flex;
                    justify-content: space-between;
                    cursor: pointer;
                    a {
                        color: white;
                        text-decoration: none;
                    }
                }
                ul.tareas {
                    list-style: none;
                    margin: 0px;
                    padding: 5px;
                    overflow: auto;
                    li {
                        display: flex;
                        align-items: center;
                        border: 1px solid #dcdfe6;
                        background-color: #ffffffd4;
                        padding: 10px;
                        margin: 0px 0px 5px 0px;
                        border-radius: 4px;
                        overflow: hidden;
                        cursor: pointer;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        text-overflow: ellipsis;
                        &:hover {
                            background-color: white;
                        }
                        &.asignada {
                            background-color: #f0f9eb !important;
                            color: #67c23a;
                            border: 1px solid #cee4c3;
                        }
                        &.selected {
                            background-color: rgb(253, 246, 236)!important;
                            color: #E6A23C!important;
                            border-color: rgb(243, 221, 189)!important;
                        }
                        p {
                            margin: 0px 5px 0px 0px;
                        }
                        span {
                            display: block;
                            flex-shrink: 0;
                            width: 40px;
                            text-align: center;
                            background-color: #67C23A;
                            color: white;
                            border-radius: 4px;
                            padding: 0px 5px;
                        }
                    }
                }
            }
        }
    }

    section.actions {
        min-height: auto;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
            margin: 0px;
            font-weight: 600;
        }
    }

    .dialog-users {
        ul {
            margin: 0px;
            padding: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            li {
                padding: 10px 15px;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                margin: 2px;
                width: calc((100% / 3) - 36px);
                cursor: pointer;
                &:hover {
                    background-color: #f4f4f4;
                }
                &.selected {
                    background-color: $--color-header!important;
                    color: white;
                }
            }
        }
    }
}
</style>